import { jsxs as c, Fragment as a, jsx as o } from "react/jsx-runtime";
import { CheckboxIndeterminateLineIcon as i, CheckboxLineIcon as m, CheckboxBlankLineIcon as s } from "@ifrc-go/icons";
function h(t) {
  const {
    className: e,
    indeterminate: n,
    value: r
  } = t;
  return /* @__PURE__ */ c(a, { children: [
    n && /* @__PURE__ */ o(
      i,
      {
        className: e
      }
    ),
    r && !n && /* @__PURE__ */ o(
      m,
      {
        className: e
      }
    ),
    !r && !n && /* @__PURE__ */ o(
      s,
      {
        className: e
      }
    )
  ] });
}
export {
  h as default
};
